import React from 'react'
import { signOut } from '../utils/supabase'
import { useAuth } from '../hooks/useAuth'

const Header = ({ clock }) => {
  const { user } = useAuth()

  const handleLogout = async () => {
    try {
      await signOut()
    } catch (error) {
      console.error('Error signing out:', error)
    }
  }

  return (
    <header className="header">
      <div className="header-title">Task Manager</div>
      <div className="header-clock">{clock}</div>
      <div className="header-user">
        <span className="user-email">{user?.email}</span>
        <button onClick={handleLogout} className="logout-button">
          Logout
        </button>
      </div>
    </header>
  )
}

export default Header